<template>
  <section class="py-4">
    <v-container>
      <v-row align="center" justify="center">
        <v-col cols="12">
          <div class="text-center">
            <h3 class="text-h4 font-weight-light mb-3">
              Curation Power
            </h3>
            <h4 class="text-body-1 mb-6">
              Curation isn't considered equally. Their weight on score depends
              on the reputation and how many photos the user curating has
              published on 100ASA.
            </h4>
            <div class="text-center">
              <img
                :src="
                  `images/reputation/power-scale${
                    $vuetify.theme.dark ? '-dark' : ''
                  }.png`
                "
                alt="Curation Power image."
                width="400"
              />
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  name: 'ReputationPower'
}
</script>
